import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Route, withRouter } from 'react-router'
import PropTypes from 'prop-types'
import { Grid, Row, Col } from 'react-flexbox-grid'
import AddContractDetails from './AddContractDetails'
import ChooseContractType from './ChooseContractType'
import OwnCenterDetails from './OwnCenterDetails'
import CompaniesActions from '../../Data/Redux/CompaniesRedux'
import CountriesActions from '../../Data/Redux/CountriesRedux'
import ConsumiblesCategoryActions from '../../Data/Redux/ConsumiblesCategoryRedux'

class AddContractContainer extends Component {
  componentWillMount() {
    const { getCountries, getConsumiblesCategory } = this.props
    getCountries()
    getConsumiblesCategory()
  }

  render() {
    const { match } = this.props

    return (
      <Grid fluid>
        <Row center="xs">
          <Col xs={12} sm={10} md={8}>
            <Route exact path={`${match.path}/`} component={ChooseContractType} />
            <Route exact path={`${match.path}/with-support/:contractId`} component={AddContractDetails} />
            <Route exact path={`${match.path}/without-support/:contractId`} component={AddContractDetails} />
            <Route exact path={`${match.path}/own-center/:contractId`} component={OwnCenterDetails} />
            {/* <Route exact path={`${match.path}/:contractType/:contractId`} component={AddContractDetails} />
            <Route exact path={`${match.path}/:contractType/:contractId`} component={AddContractDetails} />
            <Route exact path={`${match.path}/:contractType/:contractId`} component={OwnCenterDetails} /> */}
          </Col>
        </Row>
      </Grid>
    )
  }
}

AddContractContainer.propTypes = {
  /** Get the Centers available to the current Company */
  getAvailableCenters: PropTypes.func.isRequired,
  /** Fetch the list of countries where Advenio operates */
  getCountries: PropTypes.func.isRequired,
  /** Fetch the list of consumibles category of Advenio  */
  getConsumiblesCategory: PropTypes.func.isRequired,
  /** Data attributes from the current URI */
  match: PropTypes.object.isRequired,
}

const mapStateToProps = () => ({})

const mapDispatchToProps = (dispatch, { match }) => ({
  getCountries: () => dispatch(CountriesActions.getRequest()),
  getConsumiblesCategory: () => dispatch(ConsumiblesCategoryActions.getRequest()),
  getAvailableCenters: () => dispatch(CompaniesActions.getAvailableCentersRequest(match.params.id)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddContractContainer))



// WEBPACK FOOTER //
// ./src/Containers/AddContract/AddContractContainer.jsx